module.exports = __webpack_public_path__ + "img/credit-card_popup.10d1f0c1.svg";